import { render, staticRenderFns } from "./advertGroup.vue?vue&type=template&id=ec9c5be0&scoped=true"
import script from "./advertGroup.vue?vue&type=script&lang=js"
export * from "./advertGroup.vue?vue&type=script&lang=js"
import style0 from "./advertGroup.vue?vue&type=style&index=0&id=ec9c5be0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9c5be0",
  null
  
)

export default component.exports